import React, { useEffect, useState, useMemo } from "react";  
import { useAxios } from "../../../common_nextgen/axios/AxiosHelper";  
import useCustomNavigate from "../../../common_nextgen/common_components/Navigation/NextGenNavigation";  
import getBackendUrl from "../../../environment/BackendService";  
import { fetchDropdownValues } from "../../../common_nextgen/common_components/dropdown/DropdownHelper";  
import { useLocation } from "react-router-dom";  
import { ROUTE_PATHS } from "../../../common_nextgen/utils/Constants";  
import { useToast } from "../../../common_nextgen/hooks/ToastContext";  
import { downloadCSV } from "../../../common_nextgen/utils/UtilFunctions";
  
const usePharmacyNetwork = () => {  
  const { axios_helper_no_header } = useAxios();   
  const [data, setData] = useState([]);  
  const [first, setFirst] = useState(0);  
  const [rows, setRows] = useState(10);  
  const [totalRecords, setTotalRecords] = useState(0);  
  const [rowData, setRowData] = useState("");  
  const [currentPage, setCurrentPage] = useState(0);  
  const [selectedRows, setSelectedRows] = useState([]);  
  const navigateToPage = useCustomNavigate();  
  const [dropdownValues, setDropdownValues] = useState({});  
  const [isConfirmationModalOpen, setIsConfirmationModalOpen] = useState(false);  
  const [selectedOption, setSelectedOption] = useState("no");  
  const toast = useToast(); 
  const location = useLocation();  
  const {  
    ADD_PHARMACY_NETWORK,  
    EDIT_PHARMACY_NETWORK,  
    DISPLAY_PHARMACY_NETWORK,  
    COPY_PHARMACY_NETWORK,  
    PHARMACY_NETWORK_NOTE,  
    DISCOUNT_PATIENT_PAY_TABLE,
    PHARMACY_NETWORKS,
  } = ROUTE_PATHS; 

  const [stateVal, setStateVal] = useState(location.state || []);
const { currentState, previousState } = useMemo(() => {
  let [currentState = {}] = [...stateVal].reverse();
  const previousState = [...stateVal];
  previousState.splice(stateVal.length - 1, 1);
  return {
    previousState,
    currentState,
  };
}, [stateVal]);

  const {
    selectedSchedules = [],
    previousScreen = ROUTE_PATHS.PHARMACY_NETWORKS,
    currentIndex: initialIndex = 0,
    type = "",
    externalMode: initialExternalMode = false,
  } = currentState;
  const [currentIndex, setCurrentIndex] = useState(initialIndex);
 const [externalMode, setExternalMode] = useState(initialExternalMode);

  const [paramsData, setParamsData] = useState({  
    carCarrierId: selectedSchedules?.[initialIndex]?.carrier ,
    carCarrierName: "",  
    phnPharmacyNetworkId: selectedSchedules?.[initialIndex]?.networkId,  
    phnPharmacyNetworkName: selectedSchedules?.[initialIndex]?.description,  
    regRegionCode: selectedSchedules?.[initialIndex]?.region,  
    regRegionName: "",  
    phnNetworkType: selectedSchedules?.[initialIndex]?.typeId,  
    name: "",  
    phaPharmacyId: "",
    hiddenRecordIndicator: "A"  
  });   

   
  
  const screen_title = "Pharmacy for Network";  
  const screenNumber = "RCPHD001";  
  
  const formFields = [  
    { fieldLabel: "CAR Carrier ID", name: "carCarrierId", label: "Carrier Id", type: "text", fieldNature: "readOnly", value: "CAR Carrier ID", maxLength: 9 },  
    { fieldLabel: "CAR Carrier Name", name: "carCarrierName", label: "Carrier Name", type: "text", fieldNature: "readOnly", value: "CAR Carrier Name", maxLength: 25 },  
    { fieldLabel: "PHN Pharmacy Network ID", name: "phnPharmacyNetworkId", label: "Pharmacy Network", type: "text", fieldNature: "readOnly", value: "PHN Pharmacy Network ID", maxLength: 6 },  
    { fieldLabel: "PHN Pharmacy Network Name", name: "phnPharmacyNetworkName", label: "Pharmacy Network Name", type: "text", fieldNature: "readOnly", value: "PHN Pharmacy Network Name", maxLength: 35 },  
    { fieldLabel: "REG Region Code", name: "regRegionCode", label: "Region Code", type: "text", fieldNature: "readOnly", value: "REG Region Code", maxLength: 10 },  
    { fieldLabel: "REG Region Name", name: "regRegionName", label: "Region Name", type: "text", fieldNature: "readOnly", value: "REG Region Name", maxLength: 25 },  
    { fieldLabel: "PHN Network Type*ALL values", name: "phnNetworkType", label: "Network Type", type: "dropdown", fieldNature: "readOnly", value: "PHN Network Type", maxLength: 2 },  
    { fieldLabel: "PHA Pharmacy ID", name: "phaPharmacyId", label: "Pharmacy Id", type: "text", fieldNature: "editable", value: "PHA Pharmacy ID", maxLength: 12 }, 
    {
      fieldLabel: "Hidden Records Indicator*Inactive",
      name: "hiddenRecordIndicator",
      label: "Status",
      type: "dropdown",
      fieldNature: "editable",
      maxLength: 20,
    }, 
  ];  
  
  const dropdownOptions = [
    { field_label: "Hidden Records Indicator", condition: "*Inactive" },
    { field_label: "PHN Network Type",condition: "*ALL values" },
  ];  
  
  const dropdownCondition = {  
    dropDowns: dropdownOptions.map((item) => item.field_label + item.condition),  
  };  
  
  const ctaButtons = [  
    {  
      button_label: "Export as CSV",  
      button_handeler: () => {  
        exportAsCSV();  
      },  
      button_key: "",  
    },  
  ];  
  
  const menuOptions = [  
     
  ];  

  
  const columnDef = [  
    { header: "From Date", field: "phdFromDate" },  
    { header: "Thru Date", field: "phdThruDate" },  
    { header: "Pharmacy", field: "phaPharmacyId" },  
    { header: "Pharmacy Prc1", field: "phdPharmPriceSchedule" },  
    { header: "Pharmacy Pat", field: "phdPharmPatientPay" },  
    { header: "Client Prc1", field: "phdClientPriceSchedule" },  
    { header: "Client Prc2", field: "phdClient2PriceSched" },  
    { header: "Client Prc3", field: "phdClient3PriceSched" },  
    { header: "Client Pat", field: "phdClientPatientPay" },  
    { header: "Plan", field: "phdPlanOverrideSchedule" },  
    { header: "Status", field: "hiddenRecordIndicator" },  
    { header: "Name", field: "phaPharmacyFullName" },  
  ];  
  
  const parmKey = "carCarrierId";  
  
  const fetchFormData = async () => {  
    try {  
      const { carCarrierId, regRegionCode } = paramsData;  
      const raw_response = await axios_helper_no_header(  
        "GET",  
        `api/phdDiscountPatPayPharmacy/getSearchData`,  
        null,  
        {  
          carCarrierId,  
          regRegionCode,  
        }  
      );  
      const response = raw_response.responseData;  
  
      setParamsData((prevParams) => ({  
        ...prevParams,  
        carCarrierName: response.carCarrierName,  
        regRegionName: response.regRegionName,
      }));  
    } catch (error) {  
      console.error("Error fetching form data:", error);  
    }  
  };  
  
  const fetchData = async () => {  
    const page = first / rows;  
    try {  
      const { phnPharmacyNetworkId, regRegionCode, carCarrierId, phaPharmacyId,hiddenRecordIndicator } = paramsData;  
      const raw_response = await axios_helper_no_header("GET", `api/phdDiscountPatPayPharmacy`, null, {  
        page: page,  
        size: rows,  
        phnPharmacyNetworkId,  
        regRegionCode,  
        carCarrierId,  
        phaPharmacyId, 
        hiddenRecordIndicator, 
      });  
  
      const response = raw_response.responseData;  
      const pageResponse = raw_response.responsePaginationDTO;  
  
      if (response.length === 0) {  
        setData([]);  
        setTotalRecords(0);  
        toast.current.show({  
          severity: "info",  
          summary: "",  
          detail: response.responseStatus.message,  
          life: 3000,  
        });  
      } else {  
        setData(response);  
        setTotalRecords(pageResponse.totalRecords);  
        console.log(response);  
      }  
    } catch (error) {  
      console.error("Error fetching data:", error);  
      setData([]);  
      setTotalRecords(0);  
    }  
  };  
  
  const fetchDropdownData = async (dataDropdown) => {  
    try {  
      const response = await fetchDropdownValues(dataDropdown);  
      setDropdownValues(response);  
    } catch (error) {  
      console.error("Error fetching dropdown values:", error);  
    }  
  };  
  
  
  
  useEffect(() => {  
    const fetchDataSequence = async () => {  
      await fetchFormData();  
    };  
    if(selectedSchedules?.length) fetchDataSequence();  
  }, [externalMode]); 

  useEffect(() => {  
    fetchDropdownData(dropdownCondition);  
  }, []);

  useEffect(() => {  
    const fetchDataSequence = async () => {   
      fetchData();  
    };  
    if(selectedSchedules?.length) fetchDataSequence();  
  }, [paramsData, rows, currentPage, selectedOption]);  
  
  const onPageChange = (event) => {  
    setFirst(event.first);  
    setCurrentPage(event.page);  
    setRows(event.rows);  
  };  
  
  const openConfirmationModal = () => {  
    setIsConfirmationModalOpen(true);  
  };  
  
  const closeConfirmationModal = () => {  
    setIsConfirmationModalOpen(false);  
    setSelectedOption("no");  
  };  
  
  const deletePharmacyNetwork = () => {  
    if (selectedOption === "yes") {  
      const params = { carCarrierId: rowData[parmKey] };  
      axios_helper_no_header("DELETE", "api/pharmacynetwork", null, params)  
        .then((response) => {  
          const updatedItems = data.filter((item) => item[parmKey] !== rowData);  
          setTotalRecords((prevTotal) => prevTotal - 1);  
          setData(updatedItems);  
          toast.current.show({  
            severity: "success",  
            summary: "",  
            detail: response.responseStatus.message,  
            life: 3000,  
          });  
          closeConfirmationModal();  
        })  
        .catch((error) => {  
          console.error("There was an error deleting the data!", error);  
          toast.current.show({  
            severity: "error",  
            summary: "",  
            detail: error.message,  
            life: 3000,  
          });  
          closeConfirmationModal();  
        });  
    } else {  
      closeConfirmationModal();  
    }  
  };   

  const exportAsCSV = async () => {
    const queryParams = new URLSearchParams({ ...paramsData });

    try {
      const response = await axios_helper_no_header(
        "GET",
        "api/phdDiscountPatPayPharmacy/exportCsv",
        null,
        queryParams,
        "blob"
      );
      downloadCSV(response);
    } catch (error) {
      console.error("Error exporting as CSV:", error);
      toast.current.show({
        severity: "error",
        summary: "",
        detail: "Failed to export CSV. Please try again.",
        life: 3000,
      });
    }
  };

  const setCurrentIndexParamsData = () => {
    const nextIndex = currentIndex + 1;
    setCurrentIndex(nextIndex);
    setParamsData((prev) => {
      const selectedSch = selectedSchedules?.[nextIndex] || {};
      const [carCarrierId, phnPharmacyNetworkId, phnPharmacyNetworkName, regRegionCode, phnNetworkType] = [
        selectedSch.carrier || selectedSch.carCarrierId || "", 
        selectedSch.networkId || selectedSch.phnPharmacyNetworkId || "",
        selectedSch.description || selectedSch.phnPharmacyNetworkName || "",
        selectedSch.region || selectedSch.regRegionCode || "",
        selectedSch.typeId || selectedSch.phnNetworkType || "",

      ];
      return {
        ...prev,
        carCarrierId,
        phnPharmacyNetworkId,
        phnPharmacyNetworkName,
        regRegionCode,
        phnNetworkType
      }
    });
  }
  
  const leftButtons = [
    {
      button_label: "Back",
      button_handeler: () => {
        if (externalMode) {
          if (currentIndex < selectedSchedules.length - 1) {
            setCurrentIndexParamsData();
          } else {
            const message = {
              message: "navigate-to-external-program",
              url: previousScreen,
              parameters: {
                state: [...previousState],
              },
            };
            console.log("back messages", message);
            window.parent.postMessage(message, "*");
          }
        } else if (currentIndex < selectedSchedules.length - 1) {
          setCurrentIndexParamsData();
        } else {
          navigateToPage(previousScreen, previousState);
        }
      },
      button_key: "F12"
    }
  ]; 
  
  const updateParamData = (data) => {  
    setFirst(0);  
    setCurrentPage(0);  
    setParamsData(data);  
  };  

  const handleMessage = (event) => {
    const { type, data } = event.data;

    if (type === "set-params") {
      setStateVal(data);
      setExternalMode(true);
      const lastElement = data[data.length - 1];
      if (lastElement?.selectedSchedules) {
        setParamsData((prev) => ({
          ...prev,
          ...lastElement?.selectedSchedules[0]
        }))
      }
    }
    console.log("message", event.data);
  };

  useEffect(() => {
    window.addEventListener("message", handleMessage);
    return () => window.removeEventListener("message", handleMessage);
  });

  useEffect(() => {
    setCurrentIndex(initialIndex);
  }, [initialIndex]);
  useEffect(() => {
    setExternalMode(initialExternalMode);
  }, [initialExternalMode]);
  
  return {  
    screenNumber,  
    screen_title,  
    formFields,  
    dropdownValues,  
    paramsData,  
    updateParamData,  
    ctaButtons,  
    leftButtons,  
    data,  
    parmKey,  
    menuOptions,  
    columnDef,  
    setRowData,  
    selectedRows,  
    setSelectedRows,  
    first,  
    rows,  
    totalRecords,  
    currentPage,  
    onPageChange,  
    isConfirmationModalOpen,  
    closeConfirmationModal,  
    deletePharmacyNetwork,  
    setSelectedOption,  
  };  
};  
  
export default usePharmacyNetwork;  
